import { render } from "./dataTable.vue?vue&type=template&id=f75f4d7c&scoped=true"
import script from "./dataTable.vue?vue&type=script&lang=js"
export * from "./dataTable.vue?vue&type=script&lang=js"

import "./dataTable.vue?vue&type=style&index=0&id=f75f4d7c&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src989606032/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f75f4d7c"]])

export default __exports__